import React from 'react'
import { isEmpty, isObjectLike } from 'lodash'

import SettingsManager from '../managers/settings'
import SiteConfigManager from '../managers/siteconfig'
import { useSettings } from './settings'
import { getTranslations } from '../api/cms'
import { logger } from '../utils'
import Bus from '../bus'

const TranslationContext = React.createContext()
const EMPTY_TRANSLATIONS = {}

export const useTranslation = () => (
  React.useContext(TranslationContext) || EMPTY_TRANSLATIONS
)

export const TranslationProvider = (props) => {
  const {
    dictionary,
    children
  } = props

  const isDictionaryValid = isObjectLike(dictionary)

  const [
    translation,
    setTranslation
  ] = React.useState(
    isDictionaryValid ? dictionary : EMPTY_TRANSLATIONS
  )

  const { lang } = useSettings()

  const loadTranslations = (lang) => {
    logger.debug('[Translations] load handler', lang)

    isDictionaryValid || getTranslations({ lang })
      .then(res => {
        if (isEmpty(res)) {
          throw new Error(`Translation for language ${lang} not found`)
        }

        setTranslation(res)
      })
      .catch(error => {
        logger.error('Unable to load translation:', error.message)

        const [defaultLang] = SiteConfigManager.config.languages
        // If default language with code exist
        // Repeating get translation flow
        if (defaultLang && defaultLang.code) {
          SettingsManager.updateSettings({ lang: defaultLang.code })
        }
      })
  }

  const reloadTranslationsHandler = (payload) => {
    logger.debug('[Translations] re-load handler', lang, payload?.data)
    loadTranslations(lang)
  }

  React.useEffect(
    () => {
      loadTranslations(lang)

      Bus.on(Bus.events.global.reloadTranslations, reloadTranslationsHandler)

      return () => {
        Bus.off(Bus.events.global.reloadTranslations, reloadTranslationsHandler)
      }
    },
    [lang]
  )

  return (
    <TranslationContext.Provider value={translation}>
      {children}
    </TranslationContext.Provider>
  )
}
